/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewReferral
 */
export interface NewReferral {
    /**
     * 
     * @type {Date}
     * @memberof NewReferral
     */
    signUpConfirmedOn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof NewReferral
     */
    emailConfirmedOn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof NewReferral
     */
    firstShipmentConfirmedOn?: Date;
    /**
     * 
     * @type {number}
     * @memberof NewReferral
     */
    referrerId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewReferral
     */
    refereeId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewReferral
     */
    courierId?: number;
}

/**
 * Check if a given object implements the NewReferral interface.
 */
export function instanceOfNewReferral(value: object): value is NewReferral {
    return true;
}

export function NewReferralFromJSON(json: any): NewReferral {
    return NewReferralFromJSONTyped(json, false);
}

export function NewReferralFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewReferral {
    if (json == null) {
        return json;
    }
    return {
        
        'signUpConfirmedOn': json['signUpConfirmedOn'] == null ? undefined : (new Date(json['signUpConfirmedOn'])),
        'emailConfirmedOn': json['emailConfirmedOn'] == null ? undefined : (new Date(json['emailConfirmedOn'])),
        'firstShipmentConfirmedOn': json['firstShipmentConfirmedOn'] == null ? undefined : (new Date(json['firstShipmentConfirmedOn'])),
        'referrerId': json['referrerId'] == null ? undefined : json['referrerId'],
        'refereeId': json['refereeId'] == null ? undefined : json['refereeId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewReferralToJSON(json: any): NewReferral {
    return NewReferralToJSONTyped(json, false);
}

export function NewReferralToJSONTyped(value?: NewReferral | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signUpConfirmedOn': value['signUpConfirmedOn'] == null ? undefined : ((value['signUpConfirmedOn']).toISOString()),
        'emailConfirmedOn': value['emailConfirmedOn'] == null ? undefined : ((value['emailConfirmedOn']).toISOString()),
        'firstShipmentConfirmedOn': value['firstShipmentConfirmedOn'] == null ? undefined : ((value['firstShipmentConfirmedOn']).toISOString()),
        'referrerId': value['referrerId'],
        'refereeId': value['refereeId'],
        'courierId': value['courierId'],
    };
}

